var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5XxError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 233,
    viewBox: "0 0 252 233",
    width: 252,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m4 0h72c2.209139 0 4 1.790861 4 4v76h-80v-76c0-2.209139 1.790861-4 4-4z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    height: "331.2%",
    width: "331.2%",
    x: "-115.6%",
    y: "-109.4%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    type: "matrix",
    values: "0 0 0 0 0.458823529   0 0 0 0 0.494117647   0 0 0 0 0.529411765  0 0 0 0.203747736 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 107,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 186,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 41,
    opacity: 0.502348,
    r: 3.5,
    stroke: "#b1bbbd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b1bbbd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 125,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 51,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 41,
    opacity: 0.502348,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.832 169.776v-3.056h-2.832v-1.648h2.832v-3.072h1.792v3.072h2.832v1.648h-2.832v3.056z",
    opacity: 0.502348
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.832 65.776v-3.056h-2.832v-1.648h2.832v-3.072h1.792v3.072h2.832v1.648h-2.832v3.056z",
    opacity: 0.502348
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.104 41.992v-3.056h-2.832v-1.648h2.832v-3.072h1.792v3.072h2.832v1.648h-2.832v3.056z",
    opacity: 0.502348
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86 72)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b1bbbd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 80h70v10h-70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 66h28c.5522847 0 1 .4477153 1 1v2c0 .5522847-.4477153 1-1 1h-28c-.5522847 0-1-.4477153-1-1v-2c0-.5522847.4477153-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 66h3c.5522847 0 1 .4477153 1 1v2c0 .5522847-.4477153 1-1 1h-3c-.5522847 0-1-.4477153-1-1v-2c0-.5522847.4477153-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9346271 6.01927633 56.2653617 6.04236597c1.7204444.1847594 2.9679549 1.7253807 2.7908953 3.4466346l-3.4634203 33.6690358c-.1776213 1.7267145-1.7213905 2.9825026-3.4481049 2.8048813-.0046631-.0004797-.0093251-.0009698-.013986-.0014703l-56.26536172-6.042366c-1.72044437-.1847594-2.96795488-1.7253807-2.79089529-3.4466346l3.46342031-33.66903581c.1776213-1.72671446 1.7213905-2.98250258 3.4481049-2.80488128.0046631.00047968.0093251.00096979.013986.00147032zm15.1481246 21.33956997c3.6886303 0 6.6788561-3.0552705 6.6788561-6.8241377s-2.9902258-6.8241377-6.6788561-6.8241377c-3.6886304 0-6.6788562 3.0552705-6.6788562 6.8241377s2.9902258 6.8241377 6.6788562 6.8241377zm23.1795595 0c2.6037391 0 4.7144867-2.1566615 4.7144867-4.8170384 0-2.6603768-2.1107476-4.8170384-4.7144867-4.8170384s-4.7144867 2.1566616-4.7144867 4.8170384c0 2.6603769 2.1107476 4.8170384 4.7144867 4.8170384zm4.7144867 15.2365001c-6.7938696-6.4110813-12.2941041-9.6166219-16.5007034-9.6166219s-10.2306657 2.4027009-18.072199 7.2081027z",
    transform: "matrix(.99939083 -.0348995 .0348995 .99939083 -.987718 1.413646)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5XxError);
export default __webpack_public_path__ + "static/media/5xx-error.332edad7da06f5006ee79966d421ee99.svg";
export { ForwardRef as ReactComponent };